import React from 'react';
import ContentManagement from './ContentManagement';

const PoliciesContent = () => {
  return <ContentManagement page="policies" />;
};

export default PoliciesContent;
